/** Shared Firebase web config (also duplicated in public/firebase-messaging-sw.js). */
export const firebaseConfig = {
  apiKey: 'AIzaSyAXwpase3h4vFv3Y0Ta_3ckyOhoU7DhzLQ',
  authDomain: 'named-signal-309218.firebaseapp.com',
  projectId: 'named-signal-309218',
  storageBucket: 'named-signal-309218.firebasestorage.app',
  messagingSenderId: '423589948832',
  appId: '1:423589948832:web:744a7c71c22b4dc0f808c5',
  measurementId: 'G-5QDE2PQGZD',
};
